export const LOCAL_STORAGE_WORKSPACE_INVITATION = 'workspaceInvitation'
export const LOCAL_STORAGE_EVENT_INVITATION_LINK = 'eventInvitationLink'
